// @flow

// Initial Request Constants
export const INITIAL_REQUEST_FORM_ELEMENT_VALUE_CHANGE: string = "INITIAL_REQUEST_FORM_ELEMENT_VALUE_CHANGE";
export const INITIAL_REQUEST_FORM_SUBMIT_REQUEST: string = "INITIAL_REQUEST_FORM_SUBMIT_REQUEST";
export const INITIAL_REQUEST_FORM_SUBMIT_SUCCESS: string = "INITIAL_REQUEST_FORM_SUBMIT_SUCCESS";
export const INITIAL_REQUEST_FORM_SUBMIT_FAILURE: string = "INITIAL_REQUEST_FORM_SUBMIT_FAILURE";
export const INITIAL_REQUEST_FORM_ERROR_RELEASE: string = "INITIAL_REQUEST_FORM_ERROR_RELEASE";

// Login Constants
export const LOGIN_FORM_ELEMENT_VALUE_CHANGE: string = "LOGIN_FORM_ELEMENT_VALUE_CHANGE";
export const LOGIN_FORM_SUBMIT_REQUEST: string = "LOGIN_FORM_SUBMIT_REQUEST";
export const LOGIN_FORM_SUBMIT_SUCCESS: string = "LOGIN_FORM_SUBMIT_SUCCESS";
export const LOGIN_FORM_SUBMIT_FAILURE: string = "LOGIN_FORM_SUBMIT_FAILURE";
export const LOGIN_FORM_ERROR_RELEASE: string = "LOGIN_FORM_ERROR_RELEASE";

// Company Register Constants
export const COMPANY_REGISTER_FORM_ELEMENT_VALUE_CHANGE: string = "COMPANY_REGISTER_FORM_ELEMENT_VALUE_CHANGE";
export const ADD_NEW_USER_FIELD_TO_COMPANY_REGISTER_FORM: string = "ADD_NEW_USER_FIELD_TO_COMPANY_REGISTER_FORM";
export const REMOVE_USER_FIELD_FROM_COMPANY_REGISTER_FORM: string = "REMOVE_USER_FIELD_FROM_COMPANY_REGISTER_FORM";
export const COMPANY_REGISTER_FORM_ELEMENT_USER_VALUE_CHANGE: string = "COMPANY_REGISTER_FORM_ELEMENT_USER_VALUE_CHANGE";
export const COMPANY_REGISTER_FORM_SUBMIT_REQUEST: string = "COMPANY_REGISTER_FORM_SUBMIT_REQUEST";
export const COMPANY_REGISTER_FORM_SUBMIT_SUCCESS: string = "COMPANY_REGISTER_FORM_SUBMIT_SUCCESS"
export const COMPANY_REGISTER_FORM_SUBMIT_FAILURE: string = "COMPANY_REGISTER_FORM_SUBMIT_FAILURE"
export const COMPANY_REGISTER_FORM_ERROR_RELEASE: string = "COMPANY_REGISTER_FORM_ERROR_RELEASE";

// User Register Constants
export const USER_REGISTER_FORM_ELEMENT_VALUE_CHANGE: string = "USER_REGISTER_FORM_ELEMENT_VALUE_CHANGE";
export const USER_REGISTER_CONTROL_ELEMENT_VALUE_CHANGE: string = "USER_REGISTER_CONTROL_ELEMENT_VALUE_CHANGE";
export const USER_REGISTER_FORM_SUBMIT_REQUEST: string = "USER_REGISTER_FORM_SUBMIT_REQUEST";
export const USER_REGISTER_FORM_SUBMIT_SUCCESS: string = "USER_REGISTER_FORM_SUBMIT_SUCCESS";
export const USER_REGISTER_FORM_SUBMIT_FAILURE: string = "USER_REGISTER_FORM_SUBMIT_FAILURE";
export const USER_REGISTER_FORM_ERROR_RELEASE: string = "USER_REGISTER_FORM_ERROR_RELEASE";



// WEBPACK FOOTER //
// ./src/Constants/PublicAccountPages/publicAccountPagesConstants.js